import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProductCardsInventory } from './productcardsinventory.model';
import { ReportsService } from '../reports.service';
import { CategoryService } from 'src/app/cards/category/category.service';
import { SubcategoryService } from 'src/app/cards/subcategory/subcategory.service';
import { ProductService } from 'src/app/cards/product/product.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubCategory } from 'src/app/cards/subcategory/subCategory.model';
import { Category } from 'src/app/cards/category/category.model';
import { Product } from 'src/app/cards/product/product.model';

@Component({
  selector: 'app-productcardsinventory',
  templateUrl: './productcardsinventory.component.html',
  styleUrls: ['./productcardsinventory.component.css']
})
export class ProductcardsinventoryComponent implements OnInit {

  productCardInventory: ProductCardsInventory = {} as ProductCardsInventory;
  category: Category[] = [];
  subCategories: SubCategory[] = [];
  products: Product[] = [];

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  selectedCategory!: number;
  selectedSubCategory!: number;
  selectedProduct!: number;
  spinnerOverlay = false;
  constructor(private service: ReportsService,
    private categoryService: CategoryService,
    private subCategoryService: SubcategoryService,
    private productService: ProductService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.getCategory();
  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(1).subscribe(data => {
      this.category = data;
      this.spinnerOverlay = false;

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  getSubCategory() {
    this.spinnerOverlay = true;
    this.subCategoryService.getAll(this.selectedCategory, 1, false).subscribe(data => {
      this.subCategories = data
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    });
  }

  getProduct() {
    this.spinnerOverlay = true;
    this.productService.getAll(this.selectedSubCategory, 1).subscribe(data => {
      this.products = data;
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  onCategoryChange() {
    this.productCardInventory = {} as ProductCardsInventory
    this.selectedSubCategory = 0;
    this.selectedProduct = 0;
    this.subCategories = [];
    this.products = [];
    this.getSubCategory();
  }

  onsubCategoryChange() {
    this.productCardInventory = {} as ProductCardsInventory
    this.selectedProduct = 0;
    this.products = [];
    this.getProduct();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getProductCardsInventory(this.selectedProduct, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value).subscribe(data => {
        this.productCardInventory = data
        this.spinnerOverlay = false;
      }, error => {
        this.spinnerOverlay = false;
        console.log(error)
      })
  }

  search() {
    this.get();
  }

}
